'use client';

import type { CSSProperties } from 'react';
import { BlockRoot, PortalLink, tx } from '@akademi/site-builder-runtime';
import { MY_DESIGNS_HREF } from '../brand';

type Localized = string | Record<string, string>;
export interface SolarAccountDesignsLinkProps {
  title?: Localized;
  body?: Localized;
  label?: Localized;
  href?: string;
}

export function SolarAccountDesignsLink({ title = 'Your saved designs', body = 'Return to a design, compare revisions and continue planning when it suits you.', label = 'View my designs', href = MY_DESIGNS_HREF }: SolarAccountDesignsLinkProps) {
  return (
    <BlockRoot as="section" style={sectionStyle}>
      <div style={cardStyle}>
        <div><h2 style={titleStyle}>{tx(title)}</h2><p style={bodyStyle}>{tx(body)}</p></div>
        <PortalLink href={href} style={linkStyle}>{tx(label)} <span aria-hidden>→</span></PortalLink>
      </div>
    </BlockRoot>
  );
}
const sectionStyle: CSSProperties = { padding: 'clamp(24px, 5vw, 56px) var(--space-6, 24px)' };
const cardStyle: CSSProperties = { maxWidth: 1180, margin: '0 auto', padding: 'clamp(24px, 4vw, 40px)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 24, flexWrap: 'wrap', borderRadius: 'var(--radius-lg, 12px)', background: 'var(--color-surface-muted, #f1f5f9)', border: '1px solid var(--color-border-default, #cbd5e1)' };
const titleStyle: CSSProperties = { margin: 0, fontSize: 'clamp(22px, 3vw, 30px)' };
const bodyStyle: CSSProperties = { margin: '8px 0 0', maxWidth: 600, color: 'var(--color-text-secondary, #475569)', lineHeight: 1.6 };
const linkStyle: CSSProperties = { display: 'inline-flex', gap: 10, padding: '12px 18px', borderRadius: 'var(--radius-pill, 999px)', background: 'var(--color-brand-600, #1d4ed8)', color: 'var(--color-text-on-brand, #fff)', textDecoration: 'none', fontWeight: 700, whiteSpace: 'nowrap' };
